import { fetchApi, IAuthResponse, IRegisterUserData } from '@repo/sdk'

export const useShipperAuth = () => {
  const registerUser = async (data: IRegisterUserData) => {
    return await fetchApi<IAuthResponse>(`/public/shipper/users`, {
      body: JSON.stringify(data),
      method: 'POST',
    })
  }
  return { registerUser }
}
